import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

//function to convert ms to s with 1 digit precision
export function msToS(ms: number) {
  return (ms / 1000).toFixed(1);
}

/**
 * Format a duration in milliseconds into a human-readable string.
 * Examples: 850 ms, 34 s, 2m 15s, 1h 5m 3s, 1d 5h, 3d 5h 30m
 */
export function formatDuration(ms: number): string {
  ms = Math.round(ms);
  if (ms === 0) return '0ms';
  if (ms < 1000) return `${ms}ms`;

  const totalSeconds = Math.floor(ms / 1000);
  const milliseconds = ms % 1000;
  if (totalSeconds < 60) {
    return milliseconds
      ? `${totalSeconds}s ${milliseconds}ms`
      : `${totalSeconds}s`;
  }

  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (totalMinutes < 60) {
    const parts = [`${totalMinutes}m`];
    if (seconds) parts.push(`${seconds}s`);
    if (milliseconds) parts.push(`${milliseconds}ms`);
    return parts.join(' ');
  }

  const totalHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (totalHours < 24) {
    const parts = [`${totalHours}h`];
    if (minutes) parts.push(`${minutes}m`);
    if (seconds) parts.push(`${seconds}s`);
    if (milliseconds) parts.push(`${milliseconds}ms`);
    return parts.join(' ');
  }

  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  const parts = [`${days}d`];
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);
  if (seconds) parts.push(`${seconds}s`);
  if (milliseconds) parts.push(`${milliseconds}ms`);
  return parts.join(' ');
}

/**
 * Format numeric values to proper locale standards (supports US and Indian formats based on context).
 */
export function formatNumberByLocale(value: number | string | undefined | null): string {
  if (value === undefined || value === null || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return String(value);

  let locale = 'en-US';
  if (typeof window !== 'undefined' && window.navigator) {
    const navLanguage = window.navigator.language;
    // Standardize Indian locale if user has any India-based configuration
    if (navLanguage && (navLanguage === 'en-IN' || navLanguage.includes('-IN') || navLanguage.toLowerCase().includes('in'))) {
      locale = 'en-IN';
    } else {
      locale = navLanguage || 'en-US';
    }
  }
  return num.toLocaleString(locale);
}

export function formatEvalLabel(value?: string | null): string {
  return value ? value.replace(/_/g, ' ') : '';
}




